import { HataKodu } from "@kantin/shared";
import { ApiHatasi, apiOku } from "./api.js";
import type { Urun } from "./kancalar.js";

/** Ad eşleşmeleri arasında kaybolmadan barkodun tam eşleşen sahibini bulur. */
export async function urunBarkodSahibiniBul(
  barkod: string,
  urunId: string | null,
): Promise<Urun | undefined> {
  const limit = 100;
  for (let offset = 0; ; offset += limit) {
    const yanit = await apiOku<{ urunler: Urun[] }>("/urun", {
      arama: barkod,
      limit,
      offset,
    });
    const sahip = yanit.urunler.find(
      (u) => u.id !== urunId && u.barkodlar.includes(barkod),
    );
    if (sahip || yanit.urunler.length < limit) return sahip;
  }
}

/** Alanda bekleyen barkodu kayda dahil eder; taşıma için ayrıca onay gerekir. */
export async function urunBarkodlariniHazirla(
  barkodlar: string[],
  taslak: string,
  devredilecek: string[],
  urunId: string | null,
): Promise<string[]> {
  const barkod = taslak.trim();
  const sonuc = barkod && !barkodlar.includes(barkod)
    ? [...barkodlar, barkod]
    : [...barkodlar];

  if (sonuc.some((b) => !b.trim() || b.length > 64)) {
    throw new Error("Barkod 1–64 karakter olmalıdır.");
  }

  // Listedeki barkodlar formda kontrol edilir. Taslak da kontrol edilmeli ki
  // başka bir barkoda verilen taşıma onayı bu barkodu izinsiz devralmasın.
  if (barkod && !barkodlar.includes(barkod)) {
    const sahip = await urunBarkodSahibiniBul(barkod, urunId);
    if (sahip && !devredilecek.includes(barkod)) {
      throw new ApiHatasi(
        409,
        HataKodu.BARKOD_KULLANIMDA,
        "Bu barkod başka bir üründe kayıtlı.",
        { barkod, urun_id: sahip.id, urun_ad: sahip.ad },
      );
    }
  }

  return sonuc;
}
